import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Shared/Spinner";
import TrashIcon from "../../components/Icons/TrashIcon";
import DeleteModal from "../../components/Shared/DeleteModal";
import { useState } from "react";
import { toast } from "react-toastify";
import { DeleteTopicCategory } from "../../api/Certificates/DeleteTopic";
import { GetCategoriesByCertificateId } from "../../api/Certificates/CategoriesByCertificateId";
const DeleteTopic = () => {
    const { id } = useParams();
    const certificateId = id || "";
    const [isMCQOpen, setIsMCQOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const { data: QuizsDTO, isLoading: isQuizLoading } = useQuery({
        queryFn: () => GetCategoriesByCertificateId(certificateId),
        queryKey: ["certificates", certificateId],
        staleTime: 0,
        refetchInterval: 0,
    });
    const quizs = QuizsDTO?.data;
    console.log('GetCategoriesByCertificateId', quizs)
    if (isQuizLoading)
        return (
            <div className="min-h-[80vh] flex items-center justify-center">
                <Spinner />
            </div>
        );
    if (!quizs) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p>No data available</p>
            </div>
        );
    }
    const handleDeleteTopic = async (id: string) => {
        await DeleteTopicCategory(id);
        toast.success("Topic deleted successfully");
    };


    return (
        <div>
            <div className="flex justify-between items-center py-7">
                <h1 className="text-burntBlack font-bold text-[32px]">All Topics</h1>
            </div>
            <div>
                {quizs && quizs.map((mcq, index: number) => (
                    <div key={mcq.id} className="flex justify-between items-center py-4 border-b border-gray-200 relative">
                        <span>Topic {index + 1}. {mcq.name}</span>
                        <button
                            onClick={() => {
                                setSelectedId(mcq.id);
                                setIsMCQOpen(true);
                            }}
                            className="bg-red-500 text-white px-4 py-2 rounded flex items-center gap-2 duration-300 transition-all hover:bg-red-900 absolute right-0"
                        >
                            Delete <TrashIcon />
                        </button>
                        <DeleteModal
                            isOpen={isMCQOpen}
                            setIsOpen={setIsMCQOpen}
                            mutationFn={() => handleDeleteTopic(selectedId!)}
                            itemId={selectedId!}
                            queryKey="certificates"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DeleteTopic;
